import { App } from './js/main';

require('./css');

const settings = require('./config.json');

const web = new App(settings, (context) => {
  web.landing.bindAll(context);
  web.imageLoader.bindAll(context);
  web.landingsTable.bindAll(context);
});

$(document).ready(() => {
  let Landing = require('./js/landing/landing.js');
  web.landing = new Landing(web);

  let ImageLoader = require('./js/images/imageLoader.js');
  web.imageLoader = new ImageLoader(web);

  let LandingsTable = require('./js/landing/landingsTable.js');
  web.landingsTable = new LandingsTable(web);

  web.bindAll();
});

module.exports = web;



// WEBPACK FOOTER //
// ./devel/app.js